import axios from "axios";
import { signedGet, signedPost } from "./signedRequest";

const API = process.env.REACT_APP_BACKEND_URL || "";

// NOTE: DM conversation IDs are `<idA>:<idB>` (colon-separated pair id).
// `encodeURIComponent(':')` → `%3A`, but the FastAPI proxy decodes the
// path before forwarding to NestJS, so the signed path (with `%3A`) and
// the verified path (with `:`) would mismatch → 401 "Firma non valida".
// Colons are valid RFC-3986 path characters and both axios and Express
// leave them untouched, so we sign and transmit the raw id.
function dmPath(conversationId, suffix = "") {
  return `/api/v1/dm/conversations/${conversationId}${suffix}`;
}

export async function listConversations() {
  const r = await signedGet("/api/v1/dm/conversations");
  return r.data?.items || [];
}

export async function openConversation(peerId) {
  const r = await signedPost("/api/v1/dm/conversations", { peerId });
  return r.data?.conversation;
}

export async function fetchMessages(conversationId, limit = 200) {
  const r = await signedGet(`${dmPath(conversationId, "/messages")}?limit=${limit}`);
  return r.data?.items || [];
}

export async function sendEncryptedMessage(
  conversationId,
  ciphertextB64,
  nonceB64,
  attachmentObjectKey = null,
) {
  const r = await signedPost(dmPath(conversationId, "/messages"), {
    ciphertextB64,
    nonceB64,
    attachmentObjectKey,
  });
  return r.data?.message;
}

export async function markConversationRead(conversationId) {
  const r = await signedPost(dmPath(conversationId, "/read"), {});
  return r.data?.readAt;
}

export async function setConversationTimer(conversationId, ttlSeconds) {
  const r = await signedPost(dmPath(conversationId, "/timer"), { ttlSeconds });
  return r.data?.messageTtlSeconds ?? null;
}

export async function deleteEncryptedMessage(conversationId, messageId, scope = "me") {
  const r = await signedPost(
    dmPath(conversationId, `/messages/${encodeURIComponent(messageId)}/delete`),
    { scope },
  );
  return r.data;
}

export async function searchProfiles(query) {
  const q = query.trim();
  if (q.length < 2) return [];
  const r = await axios.get(`${API}/api/v1/profiles`, {
    params: { q },
    timeout: 6000,
  });
  return r.data?.items || [];
}

/** Fetch a user's public profile by identityId (no auth). */
export async function fetchProfile(identityId) {
  const r = await axios.get(`${API}/api/v1/profiles/${encodeURIComponent(identityId)}`, {
    timeout: 6000,
  });
  return r.data?.profile;
}

/** Fetch the last ~20 top-level posts published by an author (public). */
export async function fetchAuthorPosts(identityId) {
  const r = await axios.get(
    `${API}/api/v1/posts/by-author/${encodeURIComponent(identityId)}`,
    { timeout: 6000 },
  );
  return r.data?.items || [];
}
